import { render } from "./Headers.vue?vue&type=template&id=4c84b72c&scoped=true"
import script from "./Headers.vue?vue&type=script&lang=js"
export * from "./Headers.vue?vue&type=script&lang=js"

import "./Headers.vue?vue&type=style&index=0&id=4c84b72c&lang=scss&scoped=true"
import "./Headers.vue?vue&type=style&index=1&id=4c84b72c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c84b72c"],['__file',"src/js/components/Headers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c84b72c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c84b72c', __exports__)) {
    api.reload('4c84b72c', __exports__)
  }
  
  module.hot.accept("./Headers.vue?vue&type=template&id=4c84b72c&scoped=true", () => {
    api.rerender('4c84b72c', render)
  })

}


export default __exports__